import React from "react";
import FilterBar from "components/ReportsComponents/FilterBar";
import { withStyles } from "@material-ui/core";
import { SingleLabel } from "components/FilterBar/label";
import { eventTypes } from "../utils";
import { getPropertyId } from "common";
import { getEventsV2 } from "relay/event";
import moment from "moment";
import RightSection from "./FilterBarRightHeader";
import { getMonthDates } from "content/utils/commonParsing"

const styles = () => ({
  filterBy: {
    fontSize: 14,
    lineHeight: "20px",
    color: "rgba(51, 51, 51, 0.5)",
    marginRight: 16,
  },
  filterIcon: {
    width: 24,
    height: 24,
    fill: "none",
    cursor: "pointer",
    background: "linear-gradient(0deg, rgba(38, 187, 237, 0.1), rgba(38, 187, 237, 0.1)), #FFFFFF",
  },
  inactive: {
    background: "transparent",
  },
  count: {
    fontWeight: "bold",
  },
  divider: {
    margin: "0px 12px",
    height: 24,
    width: 1,
    background: "#dadada",
  },
  CsvIcon: {
    fontWeight: 600,
    color: "#4F6FAE",
    "&:hover": {
      color: "#26bbed",
    },
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    lineHeight: "20px",
  },
});

const Header = ({
  classes,
  eventType,
  dateRange,
  id,
  timezoneString,
  handleChangeEventCallback,
  ...props
}) => {
  const [typeOfEvent, setTypeOfEvent] = React.useState([eventType]);
  const [monthRange, setMonthRange] = React.useState(dateRange);
  const [events, setEvents] = React.useState([]);
  const [event, setEvent] = React.useState([id]);

  React.useEffect(() => {
    getDropDownEvents(dateRange.startAt, dateRange.endAt, eventType, true);
  }, []);

  const getDropDownEvents = async (startAt, endAt, type, init) => {
    const propertyId = getPropertyId();
    try {
      let response = await getEventsV2(propertyId, startAt, endAt, type);
      if (response && response.hyevents && response.hyevents.edges) {
        let now = moment(new Date().toISOString()).tz(timezoneString);
        let events = response.hyevents.edges.map((event) => {
          return {
            id: event.node.id,
            value: event.node.title,
            upcoming: moment(event.node.startAt).tz(timezoneString).isBefore(now) ? false : true,
          };
        });
        setEvents(events);
        if (!init) {
          if (events.length > 0) {
            setEvent([events[0].id]);
            handleChangeEventCallback(events[0]);
          } else {
            setEvent([]);
            handleChangeEventCallback(null, true);
          }
        }
      }
    } catch (err) { }
  };

  const handleEventType = (typeOfEvent) => {
    setTypeOfEvent(typeOfEvent);
    getDropDownEvents(monthRange.startAt, monthRange.endAt, typeOfEvent[0]);
  };

  const handleChangeMonth = (monthRange) => {
    setMonthRange(monthRange);
    getDropDownEvents(monthRange.startAt, monthRange.endAt, typeOfEvent[0]);
  };

  const handleEvent = (event) => {
    setEvent(event);
    let eventDetails = events.find((item) => item.id == event[0]);
    handleChangeEventCallback(eventDetails);
  };

  const getCustomLabelForEventTypes = (selected, count, name, open) => {
    return <SingleLabel open={open} name={name} singleLabel="Event" />;
  };
  const startElement = <div className={classes.filterBy}>Filter By:</div>;
  const endElement = (
    <RightSection
      classes={classes}
      {...props}
      filename={`Events_RSVP-List_${getMonthDates(monthRange)}`}
    />
  );

  const filterOptions = [
    {
      type: "selector",
      optionValue: eventTypes,
      onChange: handleEventType,
      multiple: false,
      singleSelect: true,
      value: typeOfEvent,
      getCustomLabel: getCustomLabelForEventTypes,
      disableSearch: true,
      disableAllSelect: true,
      width: 163,
    },
    {
      type: "dateRange",
      position: "left",
      value: monthRange,
      handleApply: handleChangeMonth,
      timezoneOffset: "",
    },
    {
      type: "selector",
      optionValue: events,
      onChange: handleEvent,
      multiple: false,
      singleSelect: true,
      value: event,
      getCustomLabel: getCustomLabelForEventTypes,
      disableAllSelect: true,
      searchPlaceHolder: "Enter event name here...",
    },
  ];
  return (
    <FilterBar
      startComponent={startElement}
      filterOptions={filterOptions}
      endComponent={endElement}
    />
  );
};
export default withStyles(styles)(Header);
